import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import SEO from "../../layout/SEO";
import ArticlesGrid from "../../layout/ArticlesGrid";

export default class ArticleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: "", // Vide = tous les types
      loading: false
    };
  }

  componentDidMount() {
    window.resetScript();
  }

  handleFilterChange = (type) => {
    this.setState({ selectedType: type });
  };

  render() {
    const { selectedType } = this.state;

    // Types d'articles disponibles
    const articleTypes = [
      { value: "", label: "Tous les articles" },
      { value: "STAGE", label: "Stages" },
      { value: "PPE", label: "Projets Personnels Encadrés" },
      { value: "PP", label: "Projets Personnels" },
      { value: "VEILLE_TECHNOLOGIQUE", label: "Veille Technologique" },
      { value: "VEILLE_JURIDIQUE", label: "Veille Juridique" },
      { value: "OTHER", label: "Autres" }
    ];

    return (
      <>
        <SEO
          title="Articles"
          description="Découvrez tous mes articles sur le développement web, la veille technologique, mes stages et projets personnels."
          keywords="articles, blog, développement web, veille technologique, stages, projets"
        />
        <Header active="Articles" modeDark={true} />
        <BannerSimple
          title="Articles"
          boxElement={[
            { name: "Accueil", link: "/" },
            { name: "Articles", link: window.location.pathname }
          ]}
        />

        <section className="portfolio_details_area section-gap">
          <div className="container">
            {/* Filtres */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="article-filters">
                  <h3 className="mb-3">Filtrer par type</h3>
                  <div className="filter-buttons">
                    {articleTypes.map((type) => (
                      <button
                        key={type.value}
                        className={`filter-btn ${selectedType === type.value ? 'active' : ''}`}
                        onClick={() => this.handleFilterChange(type.value)}
                      >
                        {type.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Grille d'articles avec pagination */}
            <ArticlesGrid
              type={selectedType || undefined} // undefined = tous les types
              itemsPerPage={12}
              emptyMessage="Aucun article trouvé"
            />
          </div>
        </section>

        <Footer />
      </>
    );
  }
}
